export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function isValidUserName(username: string): boolean {
  const usernameRegex = /^(?=.*\b\w+\b).*\s+\b\w+\b.*$/; ///^(?=.*\b\w+\b)(?=.*\b\w+\b).+$/;
  return usernameRegex.test(username);
}
